import React, { useEffect, useState } from "react";

import { cloneDeep, includes, keys, isEmpty, set, get, omit, isEqual } from "lodash";
import moment from "moment";
import { Button, ButtonToolbar, Message, useToaster, Loader } from "rsuite";

import useRequestHandler from "hooks/useRequestHandler";
import Api from "util/Api";
import { uniqueValuesArray } from "./partial/util";

const UserContent = ({ auth, match, history }) => {
    return (
      <>
          Insert Edit User Form
      </>
    )
}
export default UserContent;